import React, { PureComponent } from 'react';
import { Dropdown, Menu, Popover } from 'm-ui';
import { NavLink, withRouter, RouteComponentProps } from 'react-router-dom';
import { Down, Help } from '@icon-park/react';
import MenuItem from 'm-ui/lib/menu/MenuItem';
import MenuTop from 'component/MenuTop';
import { ServiceMatrix } from '@ad/kcfe-service-matrix';
import { DropdownMenu } from './DropdownMenu';
import { getAccountId, getJumpDspUrl } from 'utils/login';
import { dspSkipLog, learnLinkLog, messageInfoCloseLog } from 'utils/businesslog';
import { AD_E_HOST, KA_E_HOST, JINNIU_DSP_HOST, LSP_HOST, KUAIZHAO_HOST } from 'constants/hosts';
import { KnowledgeUrl, JuxingUrl, APP_ID_TYPE } from 'constants/constants';
import QrCode from 'assets/img/tags-code.png';
import { Tip, Alert } from '@ad/message-center';
import GoldenBull from './img/GoldenBull.svg';
import SmartInvestment from './img/SmartInvestment.svg';
import LocalPush from './img/LocalPush.svg';
import BrandAd from './img/BrandAd.svg';
import GatherStar from './img/GatherStar.svg';
import KuaiZhao from './img/KuaiZhao.svg';

import './index.less';

type HeaderProps = RouteComponentProps & {
    userInfo?: {
        userId: number;
        headUrl: string;
        userName: string;
        isKa?: boolean;
        accountUcId: number;
        accountUserId: number;
        agentUserId: number;
        adminUserId: number;
        kaAccountUcId: number;
        agentAccount: boolean;
        appId?: number;
        speedAuthorize?: any;
    };
};

const ThirdPlatform = ({ userInfo }) => {
    if (userInfo?.appId === APP_ID_TYPE.AD_SOCIAL_APP) {
        return (
            <>
                <img src={GatherStar} />
                <span style={{ marginLeft: 4 }}>前往磁力聚星</span>
            </>
        );
    }
    if (userInfo?.isKa) {
        return (
            <>
                <img src={BrandAd} />
                <span style={{ marginLeft: 4 }}>前往品广平台</span>
            </>
        );
    }
    if (userInfo?.appId === APP_ID_TYPE.DSP_APP) {
        return (
            <>
                <img src={SmartInvestment} />
                <span style={{ marginLeft: 4 }}>前往磁力智投</span>
            </>
        );
    }
    if (userInfo?.appId === APP_ID_TYPE.LSP_APP) {
        return (
            <>
                <img src={LocalPush} />
                <span style={{ marginLeft: 4 }}>前往磁力本地推</span>
            </>
        );
    }
    if (userInfo?.appId === APP_ID_TYPE.KUAIZHAO_APP) {
        return (
            <>
                <img src={KuaiZhao} />
                <span style={{ marginLeft: 4 }}>前往磁力快聘</span>
            </>
        );
    }
    return (
        <>
            <img src={GoldenBull} />
            <span style={{ marginLeft: 4 }}>前往磁力金牛</span>
        </>
    );
};

class Header extends PureComponent<HeaderProps, any> {
    state = {
        collpased: false,
        accountInfo: undefined,
        popoverShow: false,
        isHoverPlatform: false,
    };

    componentDidMount() {
        this.setState({
            accountInfo: getAccountId(),
        });
    }

    getUrl = (userInfo) => {
        if (userInfo?.appId === 2) {
            return JuxingUrl[process.env.REACT_APP_RUN_ENV];
        }

        if (userInfo?.isKa) {
            return KA_E_HOST;
        } else {
            if (userInfo?.appId === 1) {
                return AD_E_HOST;
            } else if (userInfo?.appId === APP_ID_TYPE.LSP_APP) {
                return LSP_HOST;
            } else if (userInfo?.appId === APP_ID_TYPE.KUAIZHAO_APP) {
                return KUAIZHAO_HOST;
            } else {
                return JINNIU_DSP_HOST;
            }
        }
    };

    render() {
        const { userInfo } = this.props;
        const url = this.getUrl(userInfo);

        return (
            <div className="header-wrap">
                <div className="logo">
                    <NavLink to="/" />
                </div>
                {userInfo?.accountUcId ? (
                    <>
                        <MenuTop />
                        <div className="header-right">
                            <div className="open-third-platform">
                                <a
                                    // 本地推由于走了一层效果网关，需要在代理商多账号登录的跳转时多携带一个 redirectPath 参数
                                    href={getJumpDspUrl(
                                        this.getUrl(userInfo),
                                        userInfo,
                                        userInfo?.appId === APP_ID_TYPE.LSP_APP
                                            ? `https:${this.getUrl(userInfo)}`
                                            : undefined,
                                    )}
                                    target="_blank"
                                    onClick={dspSkipLog}
                                    onMouseEnter={() => this.setState({ isHoverPlatform: true })}
                                    onMouseLeave={() => this.setState({ isHoverPlatform: false })}
                                    rel="noopener noreferrer"
                                >
                                    {this.state.isHoverPlatform ? (
                                        <ThirdPlatform userInfo={userInfo} />
                                    ) : (
                                        '投放平台'
                                    )}
                                </a>
                            </div>
                            <div className="header-right__divider" />
                            <ServiceMatrix
                                className="header-right__icon-wrap"
                                accessId={8} // 标识磁力万象 ID
                            />
                            <div className="header-right__icon-wrap">
                                <Tip onMoreMessage={() => window.open('/message/center')} />
                            </div>
                            <Alert
                                onCloseButtonClick={() => {
                                    // 点击忽略打点
                                    messageInfoCloseLog();
                                }}
                            />
                            <Dropdown
                                placement="bottomCenter"
                                overlay={
                                    <Menu style={{ width: 120, padding: '12px 0' }}>
                                        <MenuItem>
                                            {/* 学习专区链接 */}
                                            <a
                                                href={KnowledgeUrl[process.env.REACT_APP_RUN_ENV]}
                                                target="_blank"
                                                onClick={() => {
                                                    // source 代表 1:首页 2:非首页
                                                    // tab 代表 1:学习专区 2:最新动态
                                                    learnLinkLog({ source: 2, tab: 1 });
                                                }}
                                                rel="noreferrer"
                                            >
                                                学习专区
                                            </a>
                                        </MenuItem>
                                        <MenuItem>
                                            {/* 最新动态链接 */}
                                            <a
                                                href="https://docs.qingque.cn/d/home/eZQADUlQqKKqS4g7plWt6zOJB?identityId=1oE1vZDL4PE#section=h.hazef1fqdiny"
                                                target="_blank"
                                                onClick={() => {
                                                    // source 代表 1:首页 2:非首页
                                                    // tab 代表 1:学习专区 2:最新动态
                                                    learnLinkLog({ source: 2, tab: 2 });
                                                }}
                                                rel="noreferrer"
                                            >
                                                最新动态
                                            </a>
                                        </MenuItem>
                                        <MenuItem>
                                            <img
                                                src={QrCode}
                                                alt="标签手册"
                                                style={{ margin: 0, width: '100%' }}
                                            />
                                            <p
                                                style={{
                                                    fontSize: 10,
                                                    color: '#595959',
                                                    margin: '4px 0 0 0',
                                                }}
                                            >
                                                扫码进入标签手册
                                            </p>
                                        </MenuItem>
                                    </Menu>
                                }
                            >
                                <div className="header-right__icon-wrap header-right__icon-help">
                                    <Help theme="outline" size="16" fill="#333" />
                                </div>
                            </Dropdown>
                            <Dropdown
                                placement="bottomRight"
                                overlay={
                                    <DropdownMenu
                                        userId={userInfo.userId}
                                        userName={userInfo.userName}
                                        account={this.state.accountInfo}
                                    />
                                }
                                getPopupContainer={() => document.body}
                            >
                                <div className="user-wrap">
                                    <Down theme="outline" size="20" fill="#8C8C8C" />
                                    <div className="user-name-wrapper user-name-wrapper_hidden">
                                        <div className="user-name style-bold">
                                            {userInfo.userName}
                                        </div>
                                        <div className="user-id style-desc">
                                            快手ID {userInfo.userId}
                                        </div>
                                    </div>
                                    <img className="user-photo" src={userInfo.headUrl} alt="头像" />
                                </div>
                            </Dropdown>
                        </div>
                    </>
                ) : null}
            </div>
        );
    }
}

export default withRouter(Header);
